import { ColourGroup } from '../models/colour-group.model';
import { CustomPerformanceDataViewType } from '../models/customer-performance-data-view-type.enum';
import { PillarItem } from '../models/pillar-item.model';

import { getProgressDataForPillar } from './get-progress-data-for-pillar.function';

export function getPeriodPillar(
    pillarName: string,
    colourGroups: ColourGroup[],
): PillarItem {
    if (colourGroups == null || colourGroups.length === 0) {
        return {};
    }
    const progressData = getProgressDataForPillar(colourGroups);
    return {
        titleLabel: pillarName,
        viewType: CustomPerformanceDataViewType.PERIOD_VIEW,
        progressBarData: progressData,
        isChildPillar: true,
        isVisible: true,
    };
}
